import { create } from 'zustand';

let timeoutId = null;

const useNotificationStore = create((set) => ({
  notification: null,

  setNotification: (notification) => set({ notification }),

  clearNotification: () => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = null;
    set({ notification: null });
  },

  clearTimeout: () => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = null;
  },

  resetTimeout: (duration) => {
    if (timeoutId) clearTimeout(timeoutId);
    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showNotification: (type, message, duration = 3000) => {
    if (timeoutId) clearTimeout(timeoutId);
    set({ notification: { type, message } });

    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showSuccess: (message, duration = 3000) => {
    if (timeoutId) clearTimeout(timeoutId);
    set({ notification: { type: 'success', message } });

    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showError: (message, duration = 5000) => {
    if (timeoutId) clearTimeout(timeoutId);
    set({ notification: { type: 'error', message } });

    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showWarning: (message, duration = 10000) => {
    if (timeoutId) clearTimeout(timeoutId);
    set({ notification: { type: 'warning', message } });

    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showInfo: (message, duration = 3000) => {
    if (timeoutId) clearTimeout(timeoutId);
    set({ notification: { type: 'info', message } });

    if (duration > 0) {
      timeoutId = setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },
}));

export default useNotificationStore;
